// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" id=\"flag-icon-css-td\" viewBox=\"0 0 640 480\"> <g fill-rule=\"evenodd\"> <path fill=\"#000067\" d=\"M0 0h214v480H0z\"/> <path fill=\"red\" d=\"M426 0h214v480H426z\"/> <path fill=\"#ff0\" d=\"M214 0h212v480H214z\"/> </g> </svg> ";
// Exports
module.exports = code;